<template lang="pug">
	main(:class="{isHome}")#pagina
		PageError(
			v-if="loadError",
			:title="error.title",
			:message="error.message",
			:retryable="error.retryable",
			:to="error.to",
			:link-label="error.linkLabel",
			@retry="loadPagina($route.params)"
		)
		NewsArticle(v-else-if="isNoticia", :news="pagina", :translation="translation", :blocks="blocks || []", :doc="tiptapDocument")
		template(v-else)
			Banner(:contents="banner", v-if="banner.title && !isHome")
			article(:class="{ hasNavigation }")#content
				Navegacao(:contents="navigation", v-if="hasNavigation")
				Conteudo(:contents="blocks", :title="contentTitle", v-if="blocks", :class="{ hasNavigation, isIndustrias, isTrabalhe }")
				Compartilhamento(v-if="hasNavigation && !isNewsList")
</template>

<script>
import Banner from '@sections/Pagina/Banner/Banner.vue'
import Compartilhamento from '@sections/Pagina/Compartilhamento/Compartilhamento.vue'
import Conteudo from '@sections/Pagina/Conteudo/Conteudo.vue'
import Navegacao from '@sections/Pagina/Navegacao/Navegacao.vue'
import NewsArticle from '@sections/Noticia/NewsArticle/NewsArticle.vue'
import PageError from '@components/PageError/PageError.vue'
import pagina from '@/mixins/pagina'

export default {
	name: "view-pagina",
	mixins: [ pagina ],
	components: {
		Banner,
		Compartilhamento,
		Conteudo,
		Navegacao,
		NewsArticle,
		PageError,
	},
	computed: {
		contentTitle() {
			return this.isNewsList ? '' : this.translation.title
		},
		banner() {
			const banner = this.translation.banner
			if (banner)
				banner.url = banner.filePath

			return {
				title: this.translation.title,
				banner: banner ? banner : {
					url: require(`@images/paginas/banner-pagina.jpg`),
					altText: this.translation.title
				}
			}
		},
	},
}
</script>

<style lang="stylus" scoped src="./Pagina.styl"></style>
